export const getChildren = (children, childId) => {
  return children.map(child => {
    return {
      ...child,
      isSelected: child.id === childId
    };
  });
};
